import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Blog.scss";
import { useLanguage } from "../../i18n/LanguageContext";
import { footer, blog } from "../../i18n/content";
import { fetchBlogList } from "../../lib/blogApi";
import { urlForImage } from "../../lib/sanityClient";

const Blog = () => {
  const { t } = useLanguage();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let active = true;
    fetchBlogList()
      .then((data) => {
        if (active) setPosts(data);
      })
      .catch(() => {
        if (active) setPosts([]);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="blog_test_wrapper">
      <header className="lw-page-hero">
        <div className="lw-wrap">
          <div className="lw-eyebrow">
            <span className="lw-dot" />
            {t(blog.eyebrow)}
          </div>
          <h1>{t(blog.title)}</h1>
          <p>{t(blog.intro)}</p>
        </div>
      </header>

      <section className="lw-blog">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(blog.kicker)}</span>
            <h2 className="lw-h-title">{t(blog.sectionTitle)}</h2>
          </div>

          <div className="lwt-blog-list">
            {(posts || []).map((post) => (
              <Link
                className="lwt-blog-card"
                to={`/blog/${post.year}`}
                key={post.year}
              >
                <div className="lwt-blog-cover">
                  <img src={urlForImage(post.coverImage, { width: 800, height: 450 })} alt={t(post.title)} />
                  <div className="lw-reel-overlay" />
                  <div className="lw-rec">
                    <span className="lw-rec-dot" />
                    REC
                  </div>
                  <div className="lw-tag">
                    <span>{t(post.tags)}</span>
                  </div>
                  {post.upcoming && (
                    <div className="lwt-coming-soon">{t(blog.comingSoon)}</div>
                  )}
                </div>
                <div className="lwt-blog-body">
                  <span className="lwt-blog-kicker">{t(post.kicker)}</span>
                  <h3>{t(post.title)}</h3>
                  <p>{t(post.excerpt)}</p>
                  <div className="lwt-blog-meta">
                    <span>{t(post.tags)}</span>
                    <span className="lwt-blog-read">{t(blog.readStory)}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <footer className="lw-footer">
        <div className="lw-wrap lw-foot-bottom">
          <span>{t(footer.est)}</span>
          <Link to="/">{t(footer.backHome)}</Link>
        </div>
      </footer>
    </div>
  );
};

export default Blog;
